import { styled } from "@mui/material";

export const BlockContainer = styled("div")(({ theme }) => ({
  padding: `0.625rem ${theme.spacing(3)}`,
}));
